import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=25cd04bc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=25cd04bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd04bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25cd04bc')) {
      api.createRecord('25cd04bc', component.options)
    } else {
      api.reload('25cd04bc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=25cd04bc&scoped=true&", function () {
      api.rerender('25cd04bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8MoZ2adRwiYg9/JS/comp/GuestBox.vue"
export default component.exports